import { Instagram } from "lucide-react";
import { scrollToTarget } from "@/lib/lenis";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-night text-cream border-t border-cream/10 px-6 md:px-12 pt-20 pb-10"
  >
    <div className="max-w-6xl mx-auto">
      <button
        data-testid="footer-logo"
        onClick={() => scrollToTarget("#top")}
        className="font-serif text-4xl md:text-6xl tracking-tight text-left"
      >
        Embodied <span className="italic text-amethyst">Awakening</span>
      </button>
      <div className="mt-12 flex flex-col md:flex-row md:items-end justify-between gap-8">
        <p className="text-cream/60 text-sm max-w-sm leading-relaxed">
          A grounded journey through spiritual awakening with clarity,
          safety, and direction.
        </p>
        <div className="flex items-center gap-8">
          <a
            data-testid="footer-instagram-link"
            href="https://instagram.com/amaleyaosei"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-cream/70 hover:text-gold transition-colors duration-300"
          >
            <Instagram className="w-4 h-4" />
            @amaleyaosei
          </a>
          <button
            data-testid="footer-enquire-link"
            onClick={() => scrollToTarget("#enquire")}
            className="text-xs uppercase tracking-[0.2em] text-cream/70 hover:text-gold transition-colors duration-300"
          >
            Enquire
          </button>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-3 text-[11px] uppercase tracking-[0.2em] text-cream/40">
        <span>© {new Date().getFullYear()} Embodied Awakening</span>
        <span>With love, presence, and care</span>
      </div>
    </div>
  </footer>
);
